// extracted by mini-css-extract-plugin
module.exports = {"socialLink":"styles_socialLink__FvH8_","socialIcon":"styles_socialIcon__dfsrQ"};